function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 4,
  height: 16,
  fill: "none",
  viewBox: "0 0 4 16",
  role: "img"
}, props), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2,
  cy: 15,
  fill: "#666",
  rx: 2,
  ry: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "evenodd",
  d: "M1 15V0h2v15c0 .276-.448.5-1 .5s-1-.224-1-.5",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  fillRule: "evenodd",
  d: "M1 0v5.5h2V0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 1,
  x2: 3,
  y1: 12.088,
  y2: 12.088,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#949699"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.405,
  stopColor: "#BCBFC2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#949699"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 1,
  x2: 1,
  y1: 0,
  y2: 5.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.01
}))));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-map-pin-base.svg";
export { SvgComponent as ReactComponent };